/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Files_On_Thread_ErrorInputs */

const es_tools_nexata_list_files_on_thread_error = /** @type {(inputs: Tools_Nexata_List_Files_On_Thread_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al listar archivos del hilo`)
};

const en_tools_nexata_list_files_on_thread_error = /** @type {(inputs: Tools_Nexata_List_Files_On_Thread_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error listing thread files`)
};

/**
* | output |
* | --- |
* | "Error listing thread files" |
*
* @param {Tools_Nexata_List_Files_On_Thread_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_files_on_thread_error = /** @type {((inputs?: Tools_Nexata_List_Files_On_Thread_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Files_On_Thread_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_files_on_thread_error(inputs)
	return en_tools_nexata_list_files_on_thread_error(inputs)
});
export { tools_nexata_list_files_on_thread_error as "tools.nexata.list_files_on_thread_error" }